module.exports = __webpack_public_path__ + "img/notData.b6fa40ad.png";